<template>
	<section>
		<div v-if="!user || user.email.includes('guest.quomi.it')">
			<template v-if="showLogin">
				<div class="section-title" data-step-number="1">
					<h2>{{ $t("components.checkout.login.title") }}</h2>
					<div class="flex-right" v-if="showSignupLink">
						<span v-if="$mq.isDesktop()">
							{{ $t("components.checkout.login.label") }}
						</span>
						<span class="link-detail " @click="toggleSection()">
							{{ $t("components.checkout.login.link") }}
						</span>
					</div>
				</div>

				<div class="section-content flex">
					<form class="login" method="POST" @submit.prevent="login()" v-if="$root.source !== 'bennet'">

						<label>
							<input type="email" v-model="form.username" required class="form-control" :placeholder='$t("components.checkout.login.email")'>
						</label>

						<input-password
							v-model="form.password"
						/>

						<CTA
							:disabled="loadingLogin"
							:size="`small`"
							:content="$t('auth.signin.button')"
						/>
						<div class="flex flex-column align-items-center">
							<span class="my-5 tag-partner">Oppure accedi con:</span>

							<div class="login-social tag-partner">
								<v-btn
									outlined
									class=" google-btn tag-partner"
									@click="login('google')"
								>
								<i class="fab fa-google fa-1.5x"></i>
								<span class="text-bold capitalize ml-1" style="color: #4285F4">Google</span>
								</v-btn>

								<span class="mx-3">|</span>

								<CTA
									:disabled="loadingLogin"
									:size="`small`"
									@click="login('facebook')"
									class="tag-partner"
									:color="`blue`"
									:content="$t('auth.signin.facebook')"
								/>
							</div>
						</div>
					</form>
					<div v-else>

						<CTA
							:disabled="loadingLogin"
							:size="`small`"
							@click="login('bennet')"
							:color="`green`"
							:content="$t('auth.signin.providers') + ' bennet'"
						/>

					</div>
				</div>
			</template>

			<template v-else>
				<div class="section-title" data-step-number="1">
					<h2>{{ $t("components.checkout.registration.title") }}</h2>
					<div class="flex-right">
						<span v-if="$mq.isDesktop() ">
							{{ $t("components.checkout.registration.label") }}
						</span>
						<span class="link-detail" @click="toggleSection()">
							{{ $t("components.checkout.registration.link") }}
						</span>
					</div>
				</div>
				<div class="section-content">
					
					<div class="google-signup tag-partner">
						<v-btn
							:loading="gloading"
							outlined
							color="#4285f4"
							class=" google-btn tag-partner"
							@click.stop="login('google')"
						>
							<i class="fab fa-google fa-1.5x"></i>
							<strong class="ml-1 google-text">
								<span class="uppercase">R</span>egistrati con <span class="uppercase">G</span>oogle
							</strong>
						</v-btn>

						<div class="my-3">{{ $t("components.checkout.registration.divider") }}</div>
					</div>

					<form class="login" method="POST" @submit.prevent="register()" v-if="$root.source !== 'bennet'">
						<label>
							<input type="email" :value="form.email" @input="inputEmail($event)" :placeholder='$t("components.checkout.registration.email")' required class="form-control" name="email">
						</label>

						<input-password
							v-model="form.password"
						/>

						<label>
							<input type="text" v-model="form.firstname" required class="form-control" :placeholder='$t("components.checkout.registration.name")' name="firstname">
						</label>

						<label>
							<input type="text" v-model="form.lastname" required class="form-control" :placeholder='$t("components.checkout.registration.lastname")' name="lastname">
						</label>
						<div v-if="$root.source == 'galbani'" >
							<h6>Privacy – Consenso al Trattamento dei dati personali</h6>
							
							<p style="font-size: 12px"><router-link
					          :to="{name: 'privacy-policy/galbani'}"
					          target='_blank'
					          class="link-detail"
					          v-html="`Leggi l'informativa`"
					        /><br>
							Dichiaro di avere letto l'<router-link
					          :to="{name: 'privacy-policy/galbani'}"
					          target='_blank'
					          class="link-detail"
					          v-html="`Leggi l'informativa`"
					        /> resa ai sensi dell'art. 13 D.Lgs. 196/2003 e dell'art. 13 del Regolamento (UE) 2016/679 e acconsento al trattamento dei miei dati personali. L'interessato potrà in ogni momento esercitare i diritti di cui agli art. 15 (Diritto di Accesso), 16 (Diritto di rettifica), 17 (Diritto alla cancellazione), 18 (Diritto alla limitazione), 20 (Diritto alla portabilità del dato) e 21 (Diritto di opposizione) del Regolamento. L'esercizio dei Suoi diritti potrà avvenire attraverso l'invio di una richiesta scritta al Responsabile del Trattamento: biG srl via Flavio Gioia, 8, 201249 Milano o al Responsabile del trattamento dati pro tempore ove nominato, via Flavio Gioia 8 201249 Milano, indirizzo e-mail dpo@it.lactalis.com.
							</p>
							<div class="flex"><input v-model="legal1" value="1" name="legal-1" type="radio">Presto il consenso <input v-model="legal1" value="0" class="ml-2" name="legal-1" type="radio">Nego il consenso</div>

							<h6 class="mt-3">Vuoi rimanere aggiornato sulle iniziative galbani?</h6>
							<p style="font-size: 12px">Acconsento al trattamento dei dati per le finalità di marketing di cui al punto b) dell'<router-link
					          :to="{name: 'privacy-policy/galbani'}"
					          target='_blank'
					          class="link-detail"
					          v-html="`Leggi l'informativa`"
					        />, per ricevere via posta, e-mail, SMS, social network, notifiche push, fax e telefono, newsletter e comunicazioni/offerte commerciali (anche personalizzate, in caso di consenso prestato anche al successivo punto da parte di biG S.r.l . e/o di altre società del gruppo o società terze da queste designate e per analisi statistiche, sondaggi e indagini di mercato relative ai loro prodotti.
							</p>
							<div class="flex"><input v-model="legal2" value="1" name="legal-2" type="radio">Presto il consenso <input v-model="legal2" value="0" class="ml-2" name="legal-2" type="radio">Nego il consenso</div>

							<h6 class="mt-3">Acconsenti alla tua profilazione?</h6>
							<p style="font-size: 12px">Acconsento al trattamento dei dati per finalità di profilazione di cui al punto c) dell'<router-link
					          :to="{name: 'privacy-policy/galbani'}"
					          target='_blank'
					          class="link-detail"
					          v-html="`Leggi l'informativa`"
					        />, ivi incluso a mero titolo esemplificativo il trattamento dei dati relativi alle mie scelte, abitudini e preferenze di acquisto, dell'area geografica di riferimento, nonché per la creazione di profili (individuali e/o aggregati) da parte di biG S.r.l e/o di altre società del gruppo allo scopo di proporre offerte mirate.
					    </p>
							<div class="flex"><input v-model="legal3" value="1" name="legal-3" type="radio">Presto il consenso <input v-model="legal3" value="0" class="ml-2" name="legal-3" type="radio">Nego il consenso</div>
						</div>
						<div v-else>
							<checkbox @checkboxEvent="checkboxSignup = $event" :type="'signup'"></checkbox>
						</div>

						<div class="flex mt-3">
							<CTA
								:disabled="signupDisabled"
								:size="`small`"
								:content="$t('auth.signup.button')"
							/>

							<!-- <CTA
								:disabled="signupDisabled"
								:size="`small`"
								 @click="login('facebook')"
								 :color="`blue`"
								:content="$t('auth.signup.providers') + ' ' + $t('auth.signin.facebook')"
							/> -->

						</div>
					</form>
					<div v-else>
						<CTA
							:size="`small`"
							 @click="registerProvider('bennet')"
							 :color="`green`"
							:content="$t('auth.signup.providers') + ' bennet'"
						/>
					</div>
				</div>
			</template>
		</div>

		<div v-if="user && !user.email.includes('guest.quomi.it')" id="user-panel">
			<div class="section-title" data-step-number="0">
				<h2>{{ $t("components.checkout.account.title") }}</h2>
				<!--<div class="logout link-detail flex-right" @click="logout()">{{ $t("components.checkout.account.link") }}</div>-->
			</div>

			<div class="section-content">
				<div>{{ user.email }}</div>
			</div>
		</div>
	</section>
</template>

<script>
import { container } from '../../services/container'
import { OAuth } from '../../services/oauth'

import InputPassword from '../Parts/InputPassword'
import Checkbox from '../Checkbox'

import { errorStore } from '../../store/errorStore'
import { User } from '../../core/User'

export default {
	components: {
		Checkbox,
		InputPassword
	},

	props: {
		showLogin: {
			type: Boolean,
			default: true
		},
		showSignupLink: {
			type: Boolean,
			default: true
		}
	},

	data () {
		return {
			form: {},
			legal1: null,
			legal2: null,
			legal3: null,
			errorStore: errorStore.state,
			checkboxSignup: false,
			loadingLogin: false
		}
	},

	computed: {
		signupDisabled () {

			if (this.$root.source == 'galbani') {
				if (!this.legal1 || this.legal2 == null || this.legal3 == null || this.loadingLogin) {
					return true;
				}
				return false;
			}

			if (!this.checkboxSignup || this.loadingLogin) return true
			return false
		},

		user () {
			return this.$root.user
		}
	},

	methods: {
		toggleSection () {
			this.showLogin = !this.showLogin
		},

		login (provider, options) {
			if (provider) { return container.get('services.oauth').providerSignIn(provider, {}, '/checkout/subscription', options) }

			this.loadingLogin = true



			container.get('services.oauth').signIn(this.form).then(response => {
				return container.get('services.oauth').authenticate()
			}).then(response => {
				return this.$root.updateUser(new User(response.body.data.resource))
			}).then(response => {
				errorStore.removeMessage()
				this.loadingLogin = false
			}).catch(response => {
				this.loadingLogin = false
				errorStore.formatMessage(response)
			})
		},

		registerProvider (provider) {
			return this.login(provider, {url: "register"})
		},

		register () {
			this.loadingLogin = true
      
      		this.form.consent_marketing = this.legal2
      		this.form.consent_profiling = this.legal3

			container.set('services.oauth', new OAuth())
			container.get('services.oauth').signUp(this.form).then(response => {
				errorStore.removeMessage()
				return this.login()
			}).catch(response => {
				this.loadingLogin = false
				errorStore.formatMessage(response)
			})
		},

		logout () {
			container.get('services.oauth').logout()
			this.$root.updateUser(null)
		},

		inputEmail ($event) {
			this.form.email = $event.target.value
			this.form.username = $event.target.value
		}
	},
	created() {
	}
}

</script>

<style scoped>
	.login .flex {
		align-items: center;
	}

	.content {
		justify-content: flex-start;
		align-items: flex-start;
		position: relative;
		padding: 0px 20px 30px 20px;
		max-width: 1200px;
	}

	.content section {
		border-bottom: 1px solid #ededed;
		padding: 20px 60px;
	}

	.content section + .content section {
		margin-top: -1px;
	}

	form label {
		width: 100%;
		max-width: 300px;
		display: block;
	}

	.login .btn {
		width: 100%;
    	max-width: 300px;
	}

	.divider {
		margin: 0 auto;
		padding: 0 20px;
	}

	.login-social {
	
		display: flex;
		align-items: center;
	}

	.google-btn {
		display: inline-block;
		border: 1px solid #4285F4;
		outline: none;
	}
	
	.google-text {
		text-transform: lowercase;
	}
	.google-text::first-letter {
		text-transform: uppercase;
	}

	.fa-google{
  background: conic-gradient(from -45deg, #ea4335 110deg, #4285f4 90deg 180deg, #34a853 180deg 270deg, #fbbc05 270deg) 73% 55%/150% 150% no-repeat;
  background-clip: text;
  color: transparent;
	}

	@media (max-width: 1024px) {
		.login {
			max-width: 300px;
		}

		.login .flex {
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
		}

		.content section {
			padding: 20px 50px;
		}
	}

	@media (max-width: 800px) {
		form label,
		.login {
			width: 100%;
			max-width: 800px;
		}

		.login .btn {
			width: 100%;
	    	max-width: 800px;
		}
	}

	@media(min-width: 320px) and (max-width: 768px) {
		.google-signup {
			display: flex;
			flex-direction: column;
			align-items: center;
		}
	}
</style>
